<div #pdf_container class="container"></div>
<div fxFlex="30%" fxLayoutAlign="center center" style="position: absolute; right: 0px;">
    <mat-icon [ngClass]="zoomOut? 'zoom-active': 'zoom-inactive'" style="padding-right: 50px; cursor: pointer;" aria-hidden="false" fontIcon="zoom_out" title="zoom out" (click)="selectZoomType('zoom_out')"></mat-icon>
    <mat-icon [ngClass]="zoomIn? 'zoom-active': 'zoom-inactive'" style="padding-right: 50px; cursor: pointer;" aria-hidden="false" fontIcon="zoom_in" title="zoom in" (click)="selectZoomType('zoom_in')"></mat-icon>
</div>

